import { ChangeDetectionStrategy, Component } from '@angular/core'
import { TutorialType } from '@mos/api/player/dto-client'
import { Tutorial, TutorialComponent } from './tutorial'

@Component({
	imports: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `@switch (activeStepId()) {
		@case ('secret-scene-ended') {
			<span i18n="@@tutorial.secret-scene.ended">
				Tu viens de terminer un Instant Choisi, des bouts d'histoires dépendants de tes choix.</span
			>
		}
		@case ('secret-scene-journal') {
			<span i18n="@@tutorial.secret-scene.journal">
				Tu pourras suivre leur progression dans ton journal et découvrir les autres en rejouant un chapitre.
			</span>
		}
	}`,
})
export class SecretSceneTutorialComponent extends TutorialComponent {}

export const SECRET_SCENE_TUTORIAL: Tutorial = {
	id: TutorialType.SECRET_SCENE,
	component: SecretSceneTutorialComponent,
	steps: [
		{
			id: 'secret-scene-ended',
			highlightElementId: 'menu-toggle',
			position: 'right',
			openMenuAfter: true,
		},
		{
			id: 'secret-scene-journal',
			highlightElementId: 'menu-journal',
			position: 'right',
			closeMenuAfter: true,
		},
	],
}
